import { render, staticRenderFns } from "./TrainingRecordsJg.vue?vue&type=template&id=7973a021&scoped=true"
import script from "./TrainingRecordsJg.vue?vue&type=script&lang=js"
export * from "./TrainingRecordsJg.vue?vue&type=script&lang=js"
import style0 from "./TrainingRecordsJg.vue?vue&type=style&index=0&id=7973a021&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7973a021",
  null
  
)

export default component.exports